import { app } from '../../app.module'
app
  // ブランドテーブルのアクション
  .directive('brandTableActions', () => {
    return {
      restrict: 'EA',
      template: require('./brand-table-actions.pug')(),
    }
  })
